<template>
    <div>
        <scheduleList ></scheduleList>
    </div>
</template>
<script>

import scheduleList from '@/components/olympics/schedule/list.vue';

export default {
    components: {
        scheduleList
    },
    data () {
        let self = (window.x = this)
        return {
            // sport_id: 17,
        }
    },
    methods: {
        demo () {
        },
        // end 
    },
    mounted () {
        // this.getData()
    },
    watch: {},
    computed: {}
}
</script>
